import type { CNestedCatalogsTranslations } from "./pl";

export const de: CNestedCatalogsTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "Keine Informationen in diesem Bereich.",
};
